import { TitleContainer } from 'components/TitleContainer';
import { header } from './style.css';
import { RowContainer } from './RowContainer';
import { useId, type ReactElement } from 'react';
import { Icon } from 'components/Icon';
import { Tooltip } from 'react-tooltip';
import { Box } from '@ff-it/ui';

function Invoiced(): ReactElement {
  const id = useId();

  return (
    <span className="text-left">
      Invoiced <Icon icon="circle-question" data-tooltip-id={id} />
      <Tooltip id={id}>Total invoiced for selected finance period.</Tooltip>
    </span>
  );
}

export function HeaderRow(): ReactElement {
  return (
    <RowContainer
      className={header}
      client={<TitleContainer title="Client" subtitle="Payer" />}
      supplier={
        <Box display="flex" flexDirection="row">
          <TitleContainer title="Department" subtitle="Product" style={{ flex: 1 }} />
          <TitleContainer title="Provider" subtitle="Activity" style={{ flex: 1 }} />
        </Box>
      }
      block={<TitleContainer title="Block" />}
      invoices={<TitleContainer title="Invoices" subtitle="Number, checkout date, linked" />}
      source={<TitleContainer title="Target" subtitle="Invoiced" />}
      rate="Rate"
      invoiceable="Invoiceable"
      invoiced={<Invoiced />}
      balance="Balance"
      linked="Linked"
    />
  );
}
